import React, { Component } from 'react';
import styles from './doorCard.module.scss';
import classnames from 'classnames';
import API from '../utils/API';
import { Utils } from '../utils/utils';
import Loader from '../Loader'
import { notification, Modal } from 'antd'
import { strings } from '../utils/translations'
import DoorStatusPill from '../DoorStatusPill/DoorStatusPill'
import VRExpirationTag from '../VRExpirationTag/VRExpirationTag'
import history from '../utils/routes/history'

import DefaultGarageBackground from '../../img/default_garage.png';
import RemoteIcon from '../../img/icons/RemoteIcon';
import CloseIcon from '../../img/icons/closeIcon'

import CameraIcon from '../../img/icons/camera-icon.svg';
import BoxIcon from '../../img/icons/box-icon.svg';
import InfiniteIcon from '../../img/icons/infinite-icon.svg';
import ProximityIcon from '../../img/icons/proximity-icon.svg';
import EthernetIcon from '../../img/icons/ethernet-icon.svg';

import RecurrenteIcon from '../../img/icons/recurrente.svg';
import RecurrenteRedIcon from '../../img/icons/recurrente-red.svg';
import TemporaryIcon from '../../img/icons/temporal.svg';
import TemporaryRedIcon from '../../img/icons/temporal-red.svg';
import LockIcon from '../../img/icons/lock_closed.svg';
import LockOpenIcon from '../../img/icons/lock_open.svg';

import ChangingProgressProvider from "./ChangingProgressProvider";

const GUEST_UNLIMITED = 1;
const GUEST_TEMPORARY = 2;
const GUEST_RECURRENT = 3;

const IS_OPENED_TIMER 				= 6 * 1000; // ms
const IS_OPENED_TIMER_ON_TRIGGER 	= 3 * 1000; // ms
const LONG_PRESS_DELAY              = 250 // ms

export default class DoorCard extends Component
{
	constructor(props)
	{
		super(props);

		this.state =
		{
            onClickOpenDetailDoor: props.onClickOpenDetailDoor,

            name: props.name,
            image: props.image,
            imageHasError: false,

            triggeringDoor: false
        }
    }

	componentWillReceiveProps(nextProps)
	{
        //this.setCanTriggerDoorNow()
        //this.getDoorOpen()

		if (nextProps.door != null)
            this.setState({ door: nextProps.door })
	}
    componentWillUnmount()
	{
		if (this.startPermissionTimer != null)
			clearTimeout(this.startPermissionTimer);

		if (this.endPermissionTimer != null)
			clearTimeout(this.endPermissionTimer);

		if (this.isOpenTimer != null)
			clearInterval(this.isOpenTimer);

		if (this.isOpenTimerOnTrigger != null)
			clearInterval(this.isOpenTimerOnTrigger);
    }

	render()
	{
        const cardImg = (this.state.image !== null && !this.state.imageHasError) ?
                        this.state.image : DefaultGarageBackground

		return (
            <div
                id={this.props.id != null ? this.props.id : null}
                className={ classnames([styles.card,
                                        this.props.selectedDoor ? styles.selected : null,
                                        this.state.triggeringDoor ? styles.triggering : null
                            ])}
                onPointerDown={(e) =>
                {                    
                    this.mouseDownTime = Date.now()
                    this.grandientTimer = setTimeout(() =>
                    {
                        this.setState({ isPressed: true })
                    }, LONG_PRESS_DELAY)
                    
                    if (this.state.triggeringDoor)
                        return;
                    
                    this.gradientAnimationEndTimer = setTimeout(() =>
                    {
                        setTimeout(() => this.setState({ isPressed: false }), 200)
                        
                        this.sendTriggerDoor()
                        
                    }, LONG_PRESS_DELAY + 600 + 50)
                }}
                onPointerUp={() =>
                {
                    this.mouseUpTime = Date.now()
                    let timeElapsed = this.mouseUpTime - this.mouseDownTime

                    if (this.grandientTimer != null)
                    {
                        clearTimeout(this.grandientTimer)
                        this.grandientTimer = null
                    }
                    if (this.gradientAnimationEndTimer != null)
                    {
                        clearTimeout(this.gradientAnimationEndTimer)
                        this.gradientAnimationEndTimer = null
                    }
                    
                    this.setState({ isPressed: false })
                    
                    if (timeElapsed < LONG_PRESS_DELAY)
                        this.state.onClickOpenDetailDoor()
                }}
                onPointerCancel={() => this.onPointerLeave()}
                onPointerLeave={() => this.onPointerLeave()}
                onContextMenu={(event) =>
                {
                    event.preventDefault()
                }}
            >
                <div className={styles.cardImgContainer}>
                    <VRExpirationTag
                        door={this.props.door}
                        containerStyle={styles.vrExpirationTag}
                    />
                
                    <DoorStatusPill
                        door={this.props.door}
                        isTriggering={this.state.triggeringDoor}
                    />
                    
                    <img
                        className={styles.cardImg}
                        src={cardImg}
                        alt=""
                        loading="lazy"
                        decoding="async"
                        onError={() => this.setState({ imageHasError: true })}
                    />
                    <div className={styles.cardOverlay}></div>
                    <div className={classnames([styles.cardPurpleGradient, this.state.isPressed ? styles.pressed : null])}></div>
                </div>
                <div className={styles.cardBox}>
                    <div className={styles.titleCardContainer}>
                        <h4 className={styles.cardTitle}>{this.state.name}</h4>
                    </div>
                </div>
            </div>
		);
	}
    
    onPointerLeave()
    {
        this.mouseUpTime = Date.now()
        let timeElapsed = this.mouseUpTime - this.mouseDownTime

        if (this.grandientTimer != null)
        {
            clearTimeout(this.grandientTimer)
            this.grandientTimer = null
        }
        if (this.gradientAnimationEndTimer != null)
        {
            clearTimeout(this.gradientAnimationEndTimer)
            this.gradientAnimationEndTimer = null
        }
        
        this.setState({ isPressed: false })
    }

    sendTriggerDoor()
    {
        this.setState({ triggeringDoor: true })

        API.getInstance().triggerDoor(this.props.door.id)
        .then(response =>
        {
            this.setState({ triggeringDoor: false })
            
            notification.success(
            {
                message: this.state.name,
                description: strings('doorTriggered'),
                placement: 'top'
            })
        })
        .catch(error =>
        {
            console.log(error?.response)

            this.setState({ triggeringDoor: false })
            
            let isVRerror = error?.response?.data?.error?.message.includes('not virtual remote')
            notification.error(
            {
                message: this.state.name,
                description: isVRerror ? strings('doorTriggerVRerror') : strings('doorTriggerError'),
                placement: 'top'
            })
            
            if (isVRerror)
            {
                Modal.confirm(
                {
                    title: strings('virtualRemoteError'),
                    content: <div>{`${strings('doorTriggerVRerror')}\n${strings('doorTriggerVRerrorAlert')}`}</div>,
                    okText: strings('obtainRemotes'),
                    cancelText: strings('cancel'),
                    onOk: () => this.openBuyRemotesScreen(),
                    centered: true,
                    autoFocusButton: null,
                    closable: true
                })
            }
            else if (error?.response?.status == 403)
            {
                // Far Opening Restriction
                Modal.confirm(
                {
                    title: strings('farRestrictionDoor'),
                    content: strings('farRestrictionDoorError'),
                    okButtonProps: { style: { display: 'none' } },
                    cancelText: "OK",
                    centered: true,
                    autoFocusButton: null,
                    closable: true
                })
            }
        })
    }
    openBuyRemotesScreen()
    {
        history.push("/extra-virtual-remotes?house_id="+this.props.door.houseId)
    }
}